import { gql } from '__generated__';

export default gql(`
  query GetEventLayout($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      verified
      psp_connected
      event(id: $event_id) {
        id
        title
        location {
          id
          title
          description
        }
        logo {
          id
          url
        }
        start_date
        end_date
        active
        checkout_url
        resale_url
        interest_list_url
        requires_payments
        payments_enabled
        tickets_count
        ticket_categories {
          id
          title
          checkout_url
        }
      }
    }
  }
`);
